

export const reGex = (searchString) => {
    // Split the search string into words
    const searchWords = searchString.trim().split(/\s+/);

    // Generate regex patterns based on the number of words
    const patterns = {
        1: [
            // Single word patterns
            new RegExp(`\\b${searchWords[0]}\\b`, 'gi'),
            new RegExp(`\\b${searchWords[0]}`, 'i'),
            new RegExp(`${searchWords[0]}`, 'i')
        ],
        2: [
            // Two-word patterns
            new RegExp(`\\b${searchWords[0]}\\s+${searchWords[1]}\\b`, 'gi'),
            new RegExp(`\\b${searchWords[0]}\\s+${searchWords[1]}`, 'i'),
            new RegExp(`${searchWords[0]}\\s+${searchWords[1]}\\b`, 'i')
        ],
        3: [
            // Three-word patterns
            new RegExp(`\\b${searchWords[0]}\\s+${searchWords[1]}\\s+${searchWords[2]}\\b`, 'gi'),
            new RegExp(`\\b${searchWords[0]}\\s+${searchWords[1]}\\s+${searchWords[2]}`, 'i'),
            new RegExp(`${searchWords[0]}\\s+${searchWords[1]}\\s+${searchWords[2]}\\b`, 'i')
        ],
        4: [
            // Four-word patterns
            new RegExp(`\\b${searchWords[0]}\\s+${searchWords[1]}\\s+${searchWords[2]}\\s+${searchWords[3]}\\b`, 'gi'),
            new RegExp(`\\b${searchWords[0]}\\s+${searchWords[1]}\\s+${searchWords[2]}\\s+${searchWords[3]}`, 'i'),
            new RegExp(`${searchWords[0]}\\s+${searchWords[1]}\\s+${searchWords[2]}\\s+${searchWords[3]}\\b`, 'i')
        ],
        5: [
            // Five-word patterns
            new RegExp(`\\b${searchWords[0]}\\s+${searchWords[1]}\\s+${searchWords[2]}\\s+${searchWords[3]}\\s+${searchWords[4]}\\b`, 'gi'),
            new RegExp(`\\b${searchWords[0]}\\s+${searchWords[1]}\\s+${searchWords[2]}\\s+${searchWords[3]}\\s+${searchWords[4]}`, 'i'),
            new RegExp(`${searchWords[0]}\\s+${searchWords[1]}\\s+${searchWords[2]}\\s+${searchWords[3]}\\s+${searchWords[4]}\\b`, 'i')
        ]
    };

    // Return the appropriate pattern set based on number of words
    switch (searchWords.length) {
        case 1:
            return patterns[1];
        case 2:
            return patterns[2];
        case 3:
            return patterns[3];
        case 4:
            return patterns[4];
        case 5:
            return patterns[5];
        default:
            // Fallback to 5 words pattern if more than 5 words
            return patterns[5];
    }
}